import type { Store } from '../../../store/list/types';

/**
 * Select all recordings loaded.
 */
export const selectAllRecordings = (store: Store): void => {
  const {
    recordings,
    selectedRecordings,
    setSelectedAllRecordings,
    setSelectedRecordings,
    setRecordings,
  } = store.getState();

  // We use the selectedAllRecordings to know when the user meant to select
  // all the recordings in the filters (not just the number loaded in view).
  setSelectedAllRecordings(true);

  // We however still need to select the number in view so the user sees them "checked".
  setSelectedRecordings([]);

  recordings.forEach((recording) => {
    recording.selected = true;
    selectedRecordings.push({ id: recording.id, created: recording.created_epoch_time });
  });

  setRecordings(recordings);
  setSelectedRecordings(selectedRecordings);
};
